import React, { memo } from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const UserAvatar = memo(({ style, ...rest }) => {
  const { styles } = useStyle();
  return (
    <View style={[styles.container, style]}>
      <Image style={styles.image} {...rest} />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    width: size.userAvatarDefaultSize,
    height: size.userAvatarDefaultSize,
    borderRadius: size.userAvatarDefaultSize / 2,
    overflow: 'hidden',
    backgroundColor: colors.white2,
  },
  image: {
    ...StyleSheet.absoluteFillObject,
  },
}));
